import { render } from "./slide5.vue?vue&type=template&id=2c05fd2a&scoped=true"
import script from "./slide5.vue?vue&type=script&lang=js"
export * from "./slide5.vue?vue&type=script&lang=js"

import "./slide5.vue?vue&type=style&index=0&id=2c05fd2a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c05fd2a"]])

export default __exports__